<template>
<div class=dashboard>
  <information :if="isDataExists"
               :informations="viewData.importantMsg"></information>
  <status :if="isDataExists"
          :userCount="viewData.userCount"
          :callCount="viewData.callCount"
          :msgCount="viewData.msgCount"
          :deviceCount="viewData.deviceCount"></status>
  <helpList :if="isDataExists"
            :helpMsgs="viewData.helpMsgs"></helpList>
  <contact :if="isDataExists"
           :contactInfo="viewData.maintainer"></contact>
  <router-view></router-view>
  <div class="false_modal_window" v-if='showFalseModal'>
    <falseModalWindow :question='falseWord' @close="close">
    </falseModalWindow>
  </div>
  <div class="loading_modal_window" v-if='showloadingModal'>
    <loadingModalWindow @close="close">
    </loadingModalWindow>
  </div>
</div>
</template>

<script>
import information from './dashboardInformation.vue'
import status from './dashboardStatus.vue'
import helpList from './dashboardHelpList.vue'
import contact from './dashboardContact.vue'
import falseModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'

export default {
  data () {
    return {
      viewData: {},
      isDataExists: true,
      falseWord: '',
      showFalseModal: false,
      showloadingModal: false
    }
  },
  computed: {
    errorMsg () {
      return this.$store.state.error.errorMsg
    }
  },
  components: {
    information,
    status,
    helpList,
    contact,
    falseModalWindow,
    loadingModalWindow
  },
  methods: {
    close (e) {
      this.showFalseModal = false
    }
  },
  async created () {
    this.showloadingModal = true
    try {
      await this.$store.dispatch('dashboard/getDashboardInfo')
      this.viewData = this.$store.state.dashboard.dashboardInfo
      this.isDataExists = true
    } catch (error) {
      let eventNumber = this.$store.state.error.errorCode.errorCode_120001
      let eventType = 3
      let reason = 'MSGCRC0011 '
      if (error.response) {
        this.falseWord = this.errorMsg.MSGCRC0011.name + this.errorMsg.MSGCRC0011.value + 'エラーコード：{' + eventNumber + '}'
        reason += error.response.status
      } else {
        reason = 'MSGCRC0005'
        eventType = 9
        this.falseWord = this.errorMsg.MSGCRC0005.name + this.errorMsg.MSGCRC0005.value + 'エラーコード：{' + eventNumber + '}'
      }
      try {
        this.$store.dispatch('masters/writeLog', {eventNumber, eventType, reason})
      } catch (error) {
      }
      this.showFalseModal = true
    }
    this.showloadingModal = false
  }
}
</script>
<style scoped>
.dashboard {
  background-color: #f1f2f2;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/dashboard.vue